import { ErrorHandler, Injectable } from '@angular/core';
import { LoggingService } from './services/appInsights/logging.service';

@Injectable()
export class ErrorHandlerService implements ErrorHandler {
    constructor(private loggingService: LoggingService) {}

    handleError(error: Error) {
        this.loggingService.logException(error); // Manually log exception
    }
}
